var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.7152H3.925L8.4625 2.10999C8.67467 1.84745 8.77675 1.50898 8.74628 1.16903C8.7158 0.829086 8.55527 0.515513 8.3 0.297298C8.04473 0.0790819 7.71563 -0.0259025 7.3851 0.00544001C7.05456 0.0367826 6.74967 0.201885 6.5375 0.464426L0.2875 8.17802C0.245451 8.23937 0.207849 8.30383 0.175 8.37086C0.175 8.43514 0.175 8.47371 0.0875002 8.53799C0.0308421 8.68539 0.0011764 8.8423 0 9.0008C0.0011764 9.1593 0.0308421 9.31621 0.0875002 9.46362C0.0875002 9.5279 0.0874998 9.56647 0.175 9.63075C0.207849 9.69778 0.245451 9.76223 0.2875 9.82359L6.5375 17.5372C6.65503 17.6823 6.8022 17.799 6.96856 17.879C7.13491 17.959 7.31636 18.0003 7.5 18C7.79207 18.0006 8.07511 17.896 8.3 17.7043C8.42657 17.5964 8.5312 17.4638 8.60789 17.3143C8.68458 17.1647 8.73183 17.001 8.74692 16.8326C8.76202 16.6643 8.74466 16.4945 8.69586 16.333C8.64705 16.1715 8.56775 16.0215 8.4625 15.8916L3.925 10.2864H18.75C19.0815 10.2864 19.3995 10.151 19.6339 9.90986C19.8683 9.66876 20 9.34177 20 9.0008C20 8.65984 19.8683 8.33284 19.6339 8.09175C19.3995 7.85065 19.0815 7.7152 18.75 7.7152Z",
    fill: "#534DE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.14410ea2a072e8678d1488c1e1bc78d3.svg";
export { ForwardRef as ReactComponent };